// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"s0","controlPlay":"s1","controlElement":"s2","lowerControlWrapper":"s3","lowerControlIconWrapper":"s4","lowerControlIcon":"s5","show":"s6"};